import React, { FC } from 'react';
import { RouteProps, Redirect, Route } from 'react-router-dom';
import { GlobalRouteNames } from '../models/Common';

interface PrivateRouteProps extends RouteProps {
  hasPermission: boolean;
  isAuth: boolean;
}

export const PrivateRoute: FC<PrivateRouteProps> = ({ component: Component, hasPermission, isAuth, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) =>
        isAuth && hasPermission ? (
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: isAuth ? GlobalRouteNames.AccessDenied : GlobalRouteNames.LoginPage,
              state: { from: props.location },
            }}
          />
        )
      }
    />
  );
};
